import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['returnTypeSelect', 'confirmationInput', 'unitPriceDollars', 'unitPriceCents'];

  connect() {
    // Convert dollars to cents on page load
    if (this.hasUnitPriceDollarsTarget && this.hasUnitPriceCentsTarget) {
      this.convertToCents();
    }
  }

  handleReturnTypeChange(event) {
    const selectedOption = this.returnTypeSelectTarget.options[this.returnTypeSelectTarget.selectedIndex];
    const unitPrice = selectedOption.dataset.unitPrice;

    // If there's a unit_price, show confirmation dialog
    if (unitPrice && unitPrice !== '' && unitPrice !== '0.00') {
      const confirmed = confirm(`Do you want to set the revenue amount to $${parseFloat(unitPrice).toFixed(2)}?`);
      this.confirmationInputTarget.value = confirmed ? 'true' : 'false';
    } else {
      this.confirmationInputTarget.value = 'false';
    }
  }

  convertToCents() {
    if (!this.hasUnitPriceDollarsTarget || !this.hasUnitPriceCentsTarget) return;

    const dollars = parseFloat(this.unitPriceDollarsTarget.value) || 0;
    const cents = Math.round(dollars * 100);
    this.unitPriceCentsTarget.value = cents;
  }
}
